import { render, staticRenderFns } from "./QuestionText.vue?vue&type=template&id=718f6402&scoped=true&"
import script from "./QuestionText.vue?vue&type=script&lang=js&"
export * from "./QuestionText.vue?vue&type=script&lang=js&"
import style0 from "./QuestionText.vue?vue&type=style&index=0&id=718f6402&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718f6402",
  null
  
)

export default component.exports